import { Coc } from "@pmag/icons";
import { Routes } from "@src/context/router/RouterContext";
import { useAttributeConfig } from "@src/hooks/useAttributeConfig";
import { useRouter } from "@src/hooks/useRouter";
import { useWishlist } from "@src/hooks/useWishlist";
import { FormattedMessage } from "react-intl";

import { StyledButton, StyledCip } from "./WishlistButton.styles";

export const WishlistButton = () => {
    const { wishlistEnabled, wishlistClientside } = useAttributeConfig();
    const { setRoute } = useRouter();
    const { wishlist } = useWishlist();

    if (!wishlistEnabled || wishlistClientside) return null;

    return (
        <StyledButton variant="text" startIcon={<Coc size="small" />} onClick={() => setRoute(Routes.Wishlist)}>
            <FormattedMessage id="sparePartsFinder.wishlist.title" defaultMessage="Wishlist" />

            <StyledCip>{wishlist.length}</StyledCip>
        </StyledButton>
    );
};
